
export default {
    async dashboardForCps(store, { self, params }) {
        let res = await self.$request({
            url: self.$api.dashboardForCps,
            method: "get",
            params: params,
        });
        if (res && res.flag == "success") { 
            return res;
        } else {
            self.$message.error(res.msg);
        }
        return res;
    },

    async getAuthority(store, { self, params }) {
        let res = await self.$request({
            url: self.$api.checkModSetting,
            method: "get",
            params: params,
        });
        if (res && res.flag == "success") { 
            return res;
        } else {
            self.$message.error(res.msg);
        }
        return res;
    },

    async getSettingAuthority(store, { self }) {
        let res = await self.$request({
            url: self.$api.checkPubSetting,
            method: "get",
        });
        if (res && res.flag == "success") { 
            return res;
        } else {
            self.$message.error(res.msg);
        }
        return res;
    },

    async getAllUnreadCount(store, {self}) {
        let res = await self.$request({
            url: self.$api.queryUnreadCount,
            method: "post"
        });
        if (res.flag === "success") {
            if (res.data) {
                self.$store.commit('updateNotificationsAllCount', res.data.allUnreadCount) 
            } else {
                self.$store.commit('updateNotificationsAllCount', '') 
            }
        } else {
            self.$store.commit('updateNotificationsAllCount', '') 
            self.$message.error(res.msg)
        }
        return res;
    },
    
  
}


// WEBPACK FOOTER //
// ./src/stores/actions.js